import api from './api';
import { TeacherConversation, TeacherMessage } from '../types';

class TeacherMessageService {
  // Get all conversations for the current user
  async getConversations(): Promise<TeacherConversation[]> {
    const response = await api.get('/conversations/');
    if (Array.isArray(response.data)) {
      return response.data;
    } else if (response.data.results) {
      return response.data.results;
    }
    return [];
  }

  // Get or create a conversation with a teacher
  async getOrCreateConversation(teacherId: number): Promise<TeacherConversation> {
    const response = await api.post('/conversations/', { teacher_id: teacherId });
    return response.data;
  }

  // Get messages in a conversation
  async getMessages(conversationId: number): Promise<TeacherMessage[]> {
    const response = await api.get(`/conversations/${conversationId}/messages/`);
    return response.data;
  }

  // Send a message in a conversation
  async sendMessage(conversationId: number, content: string): Promise<TeacherMessage> {
    const response = await api.post(`/conversations/${conversationId}/send/`, { content });
    return response.data;
  }

  // Get total unread count
  async getUnreadCount(): Promise<number> {
    const response = await api.get('/conversations/unread_count/');
    return response.data.unread_count;
  }
}

const teacherMessageService = new TeacherMessageService();
export default teacherMessageService;
